<div class="card">
  <div class="card-header alert-danger">
    <h5>{{ Title }}</h5>
  </div>
  <div class="card-body">
    <p class="card-text" *ngIf="InstructionText">
      {{ InstructionText }}
    </p>
    <div class="card-text" *ngFor="let reason of CheckListItems">
      <div class="checkbox-wrapper" mdbTooltip="{{ reason.detail }}">
        <mdb-checkbox
          [default]="false"
          [(ngModel)]="reason.acknowledged"
          (change)="onChanged()"
        >
          {{ reason.title }}</mdb-checkbox
        >
      </div>
    </div>
  </div>
</div>
